var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file [Please Input File Description]
 * @author (zhaojun10)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { classPrefix } from '../../common/util';

/**
 * 参数说明
 * tab              必需，每个tab的文字
 * order            可选，顺序
 * disable          可选，是否不可点击
 * isActive         可选，是否active
 * skin             可选，颜色主题
 */

var TabPane = function (_Component) {
    _inherits(TabPane, _Component);

    function TabPane() {
        _classCallCheck(this, TabPane);

        return _possibleConstructorReturn(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
    }

    _createClass(TabPane, [{
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                classPrefix = _props.classPrefix,
                className = _props.className,
                isActive = _props.isActive,
                children = _props.children,
                backgroundColor = _props.backgroundColor,
                skin = _props.skin;


            var classes = classnames((_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, classPrefix + '-tab-panel', true), _defineProperty(_classnames, classPrefix + '-tab-active', isActive), _defineProperty(_classnames, classPrefix + '-tab-active-purple', isActive && skin === 'purple'), _classnames));

            var style = { backgroundColor: backgroundColor };

            return React.createElement(
                'div',
                { role: 'tabpanel', className: classes, 'aria-hidden': !isActive, style: style },
                isActive && children // 保证内部重新渲染

            );
        }
    }]);

    return TabPane;
}(Component);

TabPane.propTypes = {
    tab: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    disable: PropTypes.bool,
    isActive: PropTypes.bool,
    skin: PropTypes.string,
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    backgroundColor: PropTypes.string
};
TabPane.defaultProps = {
    classPrefix: classPrefix
};
export default TabPane;